module.exports = __webpack_public_path__ + "img/chart_push.1dc84dad.svg";